let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("g8Vga")).then(() => parcelRequire('gEuQF'));